import * as React from 'react';

export const NativeTopLeftLabel = ({
    text = 'Annonse',
    radiusClass = 'rounded-br-8',
    ...props
}) => (
    <div
        className={`absolute top-0 left-0 ${radiusClass} text-12 bg-gray-200 px-8 py-4`}
        {...props}
    >
        {text}
    </div>
);
